"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.billingFormValidator = exports.BILLING_FORM_FIELDS_DEF = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _utils = require("@htmniseko/htm-validators/utils");
var _billingFormStyles = _interopRequireDefault(require("./billingFormStyles"));
var BILLING_FORM_FIELDS_DEF = exports.BILLING_FORM_FIELDS_DEF = {
  firstName: {
    id: 'firstName',
    labelId: 'htmPayment.flywire.fields.firstName',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.top,
        input: _billingFormStyles["default"].input.square.top,
        inputError: _billingFormStyles["default"].input.square.errorTop,
        wrapper: _billingFormStyles["default"].wrapper.square.top
      }
    }
  },
  lastName: {
    id: 'lastName',
    labelId: 'htmPayment.flywire.fields.lastName',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.middle,
        input: _billingFormStyles["default"].input.square.middle,
        inputError: _billingFormStyles["default"].input.square.errorMiddle,
        wrapper: _billingFormStyles["default"].wrapper.square.middle
      }
    }
  },
  email: {
    id: 'email',
    labelId: 'htmPayment.flywire.fields.email',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.middle,
        input: _billingFormStyles["default"].input.square.middle,
        inputError: _billingFormStyles["default"].input.square.errorMiddle,
        wrapper: _billingFormStyles["default"].wrapper.square.middle
      }
    }
  },
  phoneCountry: {
    id: 'telephoneCountry',
    placeholderId: 'htmPayment.flywire.fields.countryCode',
    labelId: 'htmPayment.flywire.fields.phone',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.middleLeft,
        input: _billingFormStyles["default"].input.square.middleLeft,
        inputError: _billingFormStyles["default"].input.square.errorMiddleLeft,
        wrapper: _billingFormStyles["default"].wrapper.square.middleLeft
      }
    }
  },
  phone: {
    id: 'phone',
    labelId: 'htmPayment.flywire.fields.phone',
    styles: {
      flywire: {
        container: _billingFormStyles["default"].container.flywire.right
      },
      square: {
        container: _billingFormStyles["default"].container.square.middleRight,
        input: _billingFormStyles["default"].input.square.middleRight,
        inputError: _billingFormStyles["default"].input.square.errorMiddleRight,
        wrapper: _billingFormStyles["default"].wrapper.square.middleRight
      }
    }
  },
  address1: {
    id: 'address1',
    labelId: {
      flywire: 'htmPayment.flywire.fields.address',
      square: 'htmPayment.square.fields.address1'
    },
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.middle,
        input: _billingFormStyles["default"].input.square.middle,
        inputError: _billingFormStyles["default"].input.square.errorMiddle,
        wrapper: _billingFormStyles["default"].wrapper.square.middle
      }
    }
  },
  address2: {
    id: 'address2',
    labelId: 'htmPayment.square.fields.address2',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.middle,
        input: _billingFormStyles["default"].input.square.middle,
        inputError: _billingFormStyles["default"].input.square.errorMiddle,
        wrapper: _billingFormStyles["default"].wrapper.square.middle
      }
    }
  },
  city: {
    id: 'city',
    labelId: 'htmPayment.square.fields.city',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.middle,
        input: _billingFormStyles["default"].input.square.middle,
        inputError: _billingFormStyles["default"].input.square.errorMiddle,
        wrapper: _billingFormStyles["default"].wrapper.square.middle
      }
    }
  },
  state: {
    id: 'state',
    labelId: 'htmPayment.square.fields.state',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.middle,
        input: _billingFormStyles["default"].input.square.middle,
        inputError: _billingFormStyles["default"].input.square.errorMiddle,
        wrapper: _billingFormStyles["default"].wrapper.square.middle
      }
    }
  },
  country: {
    id: 'country',
    labelId: 'htmPayment.flywire.fields.country',
    placeholderId: 'htmPayment.flywire.fields.country',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.bottomLeft,
        input: _billingFormStyles["default"].input.square.bottomLeft,
        inputError: _billingFormStyles["default"].input.square.errorBottomLeft,
        wrapper: _billingFormStyles["default"].wrapper.square.bottomLeft
      }
    }
  },
  postalCode: {
    id: 'postalCode',
    labelId: 'htmPayment.square.fields.postcode',
    styles: {
      square: {
        container: _billingFormStyles["default"].container.square.bottomRight,
        input: _billingFormStyles["default"].input.square.bottomRight,
        inputError: _billingFormStyles["default"].input.square.errorBottomRight,
        wrapper: _billingFormStyles["default"].wrapper.square.bottomRight
      }
    }
  },
  amount: {
    id: 'amount',
    labelId: 'htmPayment.flywire.fields.amount'
  }
};
var billingFormValidator = exports.billingFormValidator = {
  square: (0, _utils.createValidator)((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, BILLING_FORM_FIELDS_DEF.address1.id, [_utils.required, (0, _utils.minLength)(5), _utils.noPOBox]), BILLING_FORM_FIELDS_DEF.address2.id, [_utils.noPOBox]), BILLING_FORM_FIELDS_DEF.city.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.email.id, [_utils.required, (0, _utils.minLength)(5)]), BILLING_FORM_FIELDS_DEF.phone.id, [_utils.required]), BILLING_FORM_FIELDS_DEF.lastName.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.firstName.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.postalCode.id, [_utils.required, (0, _utils.minLength)(4)]), BILLING_FORM_FIELDS_DEF.state.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.country.id, [_utils.required, (0, _utils.minLength)(2)])),
  flywire: (0, _utils.createValidator)((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, BILLING_FORM_FIELDS_DEF.address1.id, [_utils.required, (0, _utils.minLength)(5), _utils.noPOBox]), BILLING_FORM_FIELDS_DEF.address2.id, [_utils.noPOBox]), BILLING_FORM_FIELDS_DEF.city.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.email.id, [_utils.required, (0, _utils.minLength)(5)]), BILLING_FORM_FIELDS_DEF.phone.id, [_utils.required]), BILLING_FORM_FIELDS_DEF.lastName.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.firstName.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.country.id, [_utils.required, (0, _utils.minLength)(2)]), BILLING_FORM_FIELDS_DEF.amount.id, [_utils.required, _utils.integer]))
};